export default {
  // AI 标签相关
  aiRecommendationReasons: 'AI recommendation reasons',
  download: 'Download',
  copy: 'Copy',
  viewMore: 'View more',
  showLess: 'Show less',
  
  // Manuscript states
  manuscriptStates: {
    influencerApplied: 'Influencer applied',
    dealConfirmed: 'Deal confirmed',
    kickoffProduction: 'Kickoff production',
    submitAddress: 'Complete redemption info',
    submitAccount: 'Submit account',
    script: 'Idea/script',
    videoDraft1: 'Video draft 1',
    videoDraft2: 'Video draft 2',
    videoDraft3: 'Video draft 3',
    videoDraft4: 'Video draft 4',
    videoDraft5: 'Video draft 5',
    finalLink: 'Final link',
    applicationRejected: 'Application rejected',
  },
  
  // 标签页
  tabs: {
    overview: 'Overview',
    contentDelivery: 'Content delivery'
  },

  // 反馈相关
  feedback: {
    congratulations: 'Congratulations on successfully completing this collaboration! I would love to hear your thoughts on your experience with this influencer. Your feedback is invaluable and will help me continually optimize our collaborations in the future.',
    thankYou: 'Thank you for your feedback! I will continue to optimize the campaign results for you. Meanwhile, if you have more feedback for this collaboration, always let me know any time so that I can keep optimizing!'
  },

  // Toast 消息
  toast: {
    notMatchMessage: 'Not seeing ideal matches? Your results are based on your campaign information. Try adjusting your campaign information (audiences, core selling points, etc.) to improve match quality.',
    editSettings: 'Edit settings'
  },

  // 错误消息
  errors: {
    getApplyListFailed: '获取当前campaign下的申请列表失败：'
  },

  // 受众分布
  audienceDistribution: {
    title: 'Audience distribution',
    unknown: 'Unknown',
    firstMenuItem: '1st menu item',
    clickingMeWillNotClose: 'Clicking me will not close the menu also.',
    clickingMeWillClose: 'Clicking me will close the menu.'
  },

  // 受众概览
  audienceOverview: {
    // 加载状态
    loading: {
      keyMetrics: 'Key metrics',
      audienceInsights: 'Audience insights',
      topGeographies: 'Top geographies',
      age: 'Age',
      gender: 'Gender'
    },
    // 关键指标
    pastCollaborations: 'Past collaborations',
    keyMetrics: 'Key metrics(recent 20 posts)',
    audienceInsights: 'Influencer profile match',
    collaborationRisk: "Brand safety",
    collaborationRiskDescription: "Analyzes video transcripts, audio, visual content and text across the influencer's content history to protect your brand safety and reputation.",
    contentQuality: {
      title: "Content quality",
      originality: "Originality",
      productionQuality: "Production quality",
    },
    basicInformation: 'Basic information (AI inferred)',
    deliveryRecord: 'Delivery record',
    viewMore: 'View more',
    // 价格相关
    bestPrice: 'Influencer price',
    save: 'Saved',
    recruitmentCost: 'Recruitment cost',
    lowestCpm: 'Lowest CPM',
    commissionRate: 'Commission rate',
    predictedClicks: 'Predicted Clicks',
    predictedClicksTips: 'Clicks are predicted based on past collaborations and the influencer\'s recent performance, with anomalies filtered out to ensure the estimate reflects real engagement.',
    predictedCpc: 'Predicted CPC',
    predictedCpcTips: 'CPC (Cost Per Click) is calculated based on the influencer\'s best price and the predicted clicks, showing how much each click is expected to cost.',
    brandedContentPredictedViews: 'Branded content predicted views',
    // 工具提示
    tooltips: {
      lowerPriceIntent: 'To demonstrate a strong intent to collaborate, this influencer has voluntarily lowered their price below our suggested rate.',
      lowestPriceCalculation: 'The lowest price is calculated by multiplying the lowest CPM by the predicted views of the influencer’s branded content. The CPM reflects the creator’s audience value, which is determined by: Audience profile value, country/region value, platform value, and content relevance value',
      physicalProductSubsidy: 'AhaCreator helps subsidize influencer payments by deducting up to 60% of your product retail price.',
      predictedCpcUnavailable: 'Predicted CPC for this creator is unavailable due to insufficient historical information.',
      topMatch: 'Top match'
    },
    // AI 营销相关
    aiGenerated: 'AI-generated',
    aiGeneratedTooltip: 'Influencer profile generated by AhaCreator through analysis of the influencer\'s content, captions, and profile bio.',
    aiAgentsNegotiated: 'AI agents have negotiated the best possible price with the influencer, based on audience value (including country/region value, audience profile, platform attributes, and content relevance) and predicted branded content views',
    // 受众匹配
    overallMatchingScore: 'Match score',
    audienceName: 'Name',
    description: 'Description',
    noMatchingInfluencerProfile: 'No matching influencer profile',
    defaultMatchingReason:
      'This influencer shows some relevance to your product information based on content topics and may reach your target audience.',
    collapse: 'Collapse'
  },

  // 订单详情头部
  orderDetailHeader: {
    previous: 'Previous',
    next: 'Next',
    // 倒计时相关
    countdown: {
      leftToEnterShipping: 'left to enter shipping information',
      leftToReview: 'left to review',
      didNotTakeAction: 'You did not take action before ',
      influencerWithdrawn: '. As a result, the influencer has withdrawn from this collaboration.',
      reviewPrompt: '. Timely review builds trust and keeps your campaign on track.',
      withdrawPrompt: '. The influencer may withdraw from the collaboration once the countdown ends.',
      timelineExtensionPrompt: '\u00A0 timeline extention. If no action is taken, the request will be auto-approved.',
      pendingAccountSetup: 'left to confirm account access setup. '
    },
    // 导航相关
    navigation: {
      of: 'of'
    }
  },

  // 订单详情主要内容
  orderDetailMain: {
    // 内容信息
    contentInformation: 'Content Information',
    // 跟踪链接
    dedicatedTrackingLink: 'Dedicated tracking link for this influencer\'s performance:',
    dedicatedTrackingLinkDescription: 'Dedicated tracking link for this influencer to include in their content, enabling tracking of clicks and CPC performance.',
    // 热门内容（注释掉的代码中）
    hitContent: 'Hit content',
    hitContentDescription: 'Using its understanding of your product, AI has curated content from past viral hits, making it ideal for creators to reference in this campaign.'
  },

  // 订单达人信息
  orderInfluencer: {
    influencerRate: "Influencer rate",
    rateHistory: "Rate history",
    medianViews: "Median views",
    medianCpm: "Median CPM",
    deliverable: "Deliverable",
    overall: "Overall",
    recommendationReason: "Recommendation reason",
    matchAnalysis: "Match analysis",
    influencerProfile: "Influencer profile",
    matchReason: "Match reason",
    basicInformation: {
      accountType: "Account type",
      ageRange: "Age range",
      facePresentationDetail: "Face presention",
      gender: "Gender",
      showsFace: "Shows face",
      primaryLanguages: "Primary languages",
      voiceoverDetail: "Voice narration",
      languageFluency: "Languages fluency",
      accent: "Accent",
      otherLanguages: "Other languages",
    },
    // 按钮文案
    buttons: {
      postponeTimeline: 'Postpone the timeline',
      remove: 'Remove',
      confirm: 'Confirm',
      completeCollaboration: 'Complete collaboration',
      enterShippingInfo: 'Enter shipping information',
      terminateCollaboration: 'Terminate collaboration'
    },
    // 客服描述消息
    customerService: {
      contentSubmissionMissed: 'Hi {firstName}, I wanted to quickly update that the influencer has missed the deadline for submitting the content. I am actively following up with them through all available channels, including emails and direct messages, to expedite the submission. In the meantime, you have the option to cancel this collaboration and receive a 100% refund, including platform fees.',
      productionNotStarted: 'Hi {firstName}, I wanted to quickly update that the influencer has not started content production yet. I am actively following up with them through all available channels, including emails and direct messages, to expedite the production process. In the meantime, you have the option to cancel this collaboration and receive a 100% refund, including platform fees.',
      shippingAddressMissed: 'Hi {firstName}, I wanted to quickly update that the influencer has missed the deadline for submitting shipping address. I am actively following up with them through all available channels, including emails and direct messages, to expedite the submission process. In the meantime, you have the option to cancel this collaboration and receive a 100% refund, including platform fees.',
      slightlyBehindSchedule: 'Hi {firstName}, just a quick update — the influencer is slightly behind schedule. Our AI is already following up with them actively through multiple channels to help expedite the process. Thanks for your patience, and we\'ll keep you posted with the latest progress!'
    },
    // 错误消息
    errors: {
      networkError: 'network error!'
    },
    viewMore: 'View More',
    matchedFrom: 'Matched based on the brands you entered in the campaign info ({brandName}), including relevant or previously collaborating influencers.',
    // 唯一链接提示
    uniqueLinkAlert: {
      title: 'Enter a unique link',
      description: 'This influencer will be asked to add this unique link when posting their content and direct their audience to this link.',
      enterButton: 'Enter'
    }
  },

  // 平台和内容类型
  platformAndContentType: {
    // 营销策略
    marketingStrategy: {
      influencerMarketing: 'Influencer marketing',
      affiliateMarketing: 'Affiliate marketing'
    }
  },

  // 相同达人标记
  sameInfluencerMark: {
    // 工具提示
    tooltip: {
      description: 'This influencer is matched from your reference influencers',
      linkText: 'View reference'
    },
    // 标签文案
    label: 'Matched from reference influencers'
  },

  // 物流状态
  carrierStatus: {
    // 状态文案
    status: {
      pending: 'Pending',
      fulfilled: 'Fulfilled',
      delivered: 'Delivered',
      error: 'Tracking Error'
    },
    // 弹窗内容
    popover: {
      header: {
        courierName: 'Courier Name',
        trackingNumber: 'Tracking Number'
      },
      transit: {
        shippingDate: 'Shipping date'
      },
      error: {
        description: 'We can’t retrieve your shipment details right now. Please confirm the tracking number. If correct, the delay may be due to data sync, and the status will update once available.',
        updateTrackingNumber: 'Update tracking number'
      },
      success: {
        copySuccess: 'Tracking number copied successfully'
      }
    }
  },

  // 历史数据
  historicalData: {
    // 标题
    title: 'Historical performance on AhaCreator',
    // 完成合作数量
    completedCollaborations: 'completed collaborations on AhaCreator',
    // 指标标签
    metrics: {
      averageCpm: 'Average CPM',
      averageCpc: 'Average CPC',
      averageViews: 'Average views',
      averageClicks: 'Average clicks'
    }
  },

  // 合作完成提示
  collaborationComplete: {
    title: 'Congratulations! Your collaboration is now complete.',
    description: 'At AhaCreator, we guarantee a full refund if the influencer\'s content is of low quality or contains fake views or engagements. If you notice any issues, you can report this influencer or reach out to our support team at',
    reportButton: 'Report this influencer'
  },

  // 广告报告模态框
  modalAdsReport: {
    // 报告类型
    reportType: {
      additionalPayment: 'This influencer asked for additional payment',
      outsideHead: 'This influencer wanted to communicate outside AhaCreator',
      notMeetExpectations: 'The influencer\'s content did not align with my expectations, despite prior communication',
      fakeViewsEngagements: 'This influencer\'s content contains fake views or engagements',
      otherReasons: 'Other reasons: '
    },
    // 模态框标题和内容
    modal: {
      title: 'Report this influencer',
      reportReasonTitle: 'Why do you wish to report this influencer?',
      required: '*',
      uploadTitle: 'Upload screenshots / documents',
      uploadDescription: 'This helps us speed up the resolution process for you',
      uploadText: 'Upload',
      reportSubmittedTitle: 'Report submitted!',
      reportSubmittedMessage: 'We\'re reviewing your report and will follow up shortly.\nStay tuned!',
      ok: 'OK',
      blockInfluencer: 'Block influencer',
      blockInfluencerDescription: 'Block the influencer, and no future invitations will be sent to them',
    },
    // 表单相关
    form: {
      placeholder: 'Let us know why you\'re reporting this influencer…',
      selectReasonWarning: 'Please select the reason for reporting',
      submissionFailed: 'Submission failed, Try again later!'
    }
  },

  // 未找到理想达人模态框
  notFindInfluencersModal: {
    // 模态框标题
    title: 'Not finding ideal influencers?',
    // 有商业信息记录时的内容
    hasBusinessInfo: {
      description: 'Over 70% of the creators you reviewed were marked as',
      notMatch: 'Not a match',
      description2: '. This usually means your campaign details',
      campaignDetails: '(such as business introduction, audience, key selling points)',
      description3: 'could use some fine-tuning to improve matching accuracy.',
      description4: 'Would you like AhaCreator to automatically refine your campaign brief to improve influencer matches? You can also choose to refine everything yourself using the tutorial below.',
      note: 'Note: Any details you\'ve manually edited will stay exactly as they are — only the AI-generated sections will be optimized.'
    },
    // 没有商业信息记录时的内容
    noBusinessInfo: {
      description: 'Your influencer approval rate is lower than average (30%+). Influencer matches are based on your campaign information — including your',
      campaignInfo: 'audiences, core selling points, business introduction.',
      description2: 'Try adjusting your campaign information to improve match quality.'
    },
    // 按钮文案
    buttons: {
      notNow: 'Not now',
      editManually: 'Edit campaign info manually',
      optimizeWithAI: 'Optimize with AI'
    },
    // 视频相关
    video: {
      title: 'YouTube video player'
    }
  },

  // 订单详情通知
  orderDetailNotice: {
    // 地址提供通知
    addressRequired: {
      description: 'The influencer is expected to provide shipping address before'
    },
    // 内容提交通知
    contentSubmission: {
      description: 'The creator is expected to submit the',
      script: 'script',
      content: 'content',
      productionKickoff: 'kickoff the production',
      productionKickoffDescription: 'The creator is expected to start production by: {date}',
      finalLink: 'final link',
      before: 'before'
    },
    // 账号信息通知
    pendingCreatorAccountInfo: {
      description: 'The influencer is expected to submit account details before {date}',
    },
    // 账号设置通知
    pendingAccountSetup: {
      description: ' Timely feedback builds trust and keeps your campaign on track.',
    }
  },

  // 拒绝信息
  rejectInfo: {
    // 标题
    title: 'Previously rejected by you',
    // 活动名称
    campaignName: 'The Future of AI',
    // 拒绝时间
    lastRejectedOn: 'Last rejected on',
    // 拒绝原因
    rejectionReason: 'Rejection reason :'
  },

  // 物流详情
  shippingDetail: {
    // 标题
    title: 'Shipping details',
    // 地址标签
    addressLabels: {
      address: 'Address',
      zipCode: 'Zip code',
      rfc: 'Tax Identification Number (RFC)'
    }
  },

  // 受众画像标题与说明
  audienceDemographics: {
    title: 'Audience demographics',
    verifiedData: 'Verified data',
    verifiedDataTooltip: 'Displays the actual audience reached by the influencer\'s published content, based on data from the influencer\'s authorized accounts or uploaded backend screenshots.',
    description: 'Unlike modeled estimates used by some platforms, AhaCreator\'s verified data comes directly from influencer-authorized accounts or submitted backend screenshots, making it the most accurate audience reference.'
  },

  // 受众图表
  audienceCharts: {
    // 年龄图表
    ageChart: {
      title: 'Age'
    },
    // 性别图表
    genderChart: {
      title: 'Gender'
    },
    // 地理分布图表
    geographies: {
      title: 'Top geographies',
      otherGeographies: 'Other geographies',
      targetedGeographyCoverage: 'Targeted geography coverage (%)',
      viewMore: 'View more',
      collapse: 'Collapse',
      items: 'items',
      unknown: 'Unknown',
      audienceMatchTitle: 'Top locations',
      audienceMatchDescription: 'Displays the actual audience reached by the influencer’s published content, based on data from the influencer’s authorized accounts or uploaded backend screenshots.',
    }
  },
  ratingInfo: {
    description: 'Please take a moment to leave a review, highlighting aspects such as delivery, quality, and communication. Your feedback ensures we can match you with the best influencers and helps our community grow stronger.',
    rateButton: 'Rate this influencer',
    rateButton2: 'Review'
  },
  rateScore: {
    noRatingYet: "No rating yet",
    noRatingYetDescription: "Not enough activity yet to provide a rating for this influencer",
    description: "This score helps you quickly assess an influencer's overall reliability and collaboration performance on the AhaCreator platform. It’s a composite score built from two key dimensions:",
    tip1: '<b>Brand feedback:</b> Based on verified ratings from brands regarding communication, content quality, and collaboration experience.',
    tip2: '<b>Platform performance metrics:</b> Derived from objective platform data such as on-time delivery rate, response speed, and cooperation completion rate.'
  },
  accountInformation: {
    title: 'Account Information',
    description: 'Used to enable influencer account access or add credits on {productName}'
  },
  contentPerformance: {
    title: 'Engagement & Activity (recent 20 posts)',
    engagementRate: 'Median engagement rate',
    views: 'Views (median)',
    likes: 'Median likes',
    comments: 'Median comments',
    shares: 'Median shares',
    saves: 'Median saves',
    postFrequency: "Median post frequency",
    postFrequencyUnit: " posts/w",
    averageViews: 'Average views',
    lastUpdatedTime: 'Last post date',
    engagementRateTipsYoutube: 'Engagement rate reflects how audiences interact with recent content: (Likes + comments) ÷ post views',
    engagementRateTipsTiktok: 'Engagement rate reflects how audiences interact with recent content: (likes + comments + shares + saves) ÷ post views',
    engagementRateTipsInstagram: 'Engagement rate reflects how audiences interact with recent content: (likes + comments) ÷ post views',
    engagementRateTipsLinkedIn: '      Engagement rate reflects how audiences interact with recent content: (likes + comments + shares) ÷ post views',
    engagementRateTipsX: 'Engagement rate reflects how audiences interact with recent content: (likes + comments + saves + shares) ÷ post views',
    engagementQuality: 'Engagement quality',
    engagementQualityDescription: 'Strong engagement quality. Comments show genuine user discussions with minimal bot presence. Overall interaction health is good.',
  },
  productDetail: {
    title: 'Product details'
  },
  negotiationRecords: {
    viewNegotiationRecords: 'View price history',
    BRAND_RATE_NOT_IN_SCOPE: 'Please enter an offer greater than your previous offer.',
    INFLUENCER_RATE_NOT_IN_SCOPE: 'The brand has updated their offer. Please refresh the page to view the latest offer.',
    BRAND_OFFER_UPDATED: 'The influencer has updated their rate. Please refresh the page to view the latest price before confirming.',
    BRAND_OFFER_UPDATED_BEFORE_CONFIRM: 'The brand has updated their offer. Please refresh the page to view the latest price before confirming.',
  },
  notes: {
    title: 'Notes',
    addNote: 'Add note',
    addEditNote: 'Add/Edit note',
    modalTitle: 'Add notes to yourself'
  },
  promotionalLink: {
    title: 'Promotional link'
  },

  // 订单类型描述
  orderTypeDescription: {
    dedicatedVideo: 'A standalone YouTube video created specifically to focus entirely on promoting the brand.',
    integratedVideo: 'A YouTube video that seamlessly incorporates brand promotion within your regular content.',
    reels: 'A short Instagram video created to exclusively promote a brand.',
    carouselPost: 'A single Instagram post featuring multiple brand photos or videos that users can swipe through.',
    tiktokVideo: 'Exclusive TikTok video custom-made specifically for the brand.',
    linkedinVideoPost: 'A professional video post where you speak about or demonstrate the brand — such as use cases, expert opinions, or testimonials.',
    linkedinImagePost: 'A carousel post featuring branded visuals, infographics, or professional photos.',
    twitterPost: 'Exclusive X post custom-made specifically for the brand.'
  },
};
